import React, { useState, useRef, useEffect } from 'react';
import './Tooltip.css';

interface TooltipProps {
  children: React.ReactNode;
  title: string;
  description: string;
}

const Tooltip: React.FC<TooltipProps> = ({ children, title, description }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isVisible && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      
      setPosition({
        top: rect.bottom + 8,
        left: rect.left + rect.width / 2 - 150, // 300px 너비 기준 중앙 정렬
      });
    }
  }, [isVisible]);

  return (
    <div className="tooltip-wrapper" ref={tooltipRef}>
      <div
        className="tooltip-trigger"
        ref={triggerRef}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        {children}
      </div>
      {isVisible && (
        <div 
          className="tooltip-popup"
          style={{
            top: `${position.top}px`,
            left: `${Math.max(10, Math.min(position.left, window.innerWidth - 320))}px`,
          }}
        >
          <div className="tooltip-arrow"></div>
          <div className="tooltip-content">
            <div className="tooltip-title">{title}</div>
            <div className="tooltip-description">{description}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
